<p>
  skeleton-builder-project works!
</p>
